import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UserModel } from '../../_models/user.model';
import { environment } from '../../../../../environments/environment';
import { AuthModel } from '../../_models/auth.model';
import { map, shareReplay, tap } from 'rxjs/operators';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthHTTPService {
  constructor(private http: HttpClient) { }


  getAccessToken(gToken): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/token`, null, {
      headers: new HttpHeaders({
        'from': gToken,
      })
    })
      .pipe(shareReplay())
  }

  loginWith(auth: AuthModel) {
    return this.http.get<any>(`${environment.apiUrl}/admin/auth/${auth.platform}/redirect?redirect=${location.origin}/auth/login`, {
      headers: new HttpHeaders({
        'from': auth.guestToken,
        'Authorization': auth.codeToken
      })
    })
  }

  verifyLoginWith(code, auth: AuthModel) {
    return this.http.post<any>(`${environment.apiUrl}/admin/auth/${auth.platform}/login`, { code, redirect: `${location.origin}/auth/login` }, {
      headers: new HttpHeaders({
        'from': auth.guestToken,
        'Authorization': auth.codeToken
      })
    });
  }

  login(body,isLoginMailService) {
    const url = isLoginMailService ? `${environment.apiUrl}/admin/auth/login-ldap` : `${environment.apiUrl}/admin/auth/login`;
    return this.http.post<any>(`${url}`, body);
  }

  getUserProfile(token){
    const httpHeaders = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http.get<UserModel | any>(`${environment.apiUrl}/admin/area/profile`, {
      headers: httpHeaders,
    }).pipe(
      tap(res => {
        let permissions = res?.item?.permissions;
        let keys = this.getPermissionsIds(permissions);
        localStorage.setItem('permissionsIds', JSON.stringify(keys));
      }),
      map(res => {
      if(res?.item?.permissions?.settings?.Hawsabah){
        res.item.permissions.settings.Hawsabah = {
          hawsabah : res?.item?.permissions?.settings?.Hawsabah
        }
      }
      return res
    }));
  }

  getPermissionsIds(permissions) {
    let keys = [];
    for (let key in permissions) {
      if (permissions.hasOwnProperty(key)) {
        if (typeof permissions[key] === 'object') {
          keys.push(...this.getPermissionsIds(permissions[key]));
        } else {
          keys.push(permissions[key]);
        }
      }
    }
    return keys;
  }




}


